import { OnAnimationFrame } from "../../../library-js/animation/OnAnimationFrame";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { MathX } from "../../../library-js/math/MathX";

export class RainbowStyle
{
  background:string;
  color:string;
  filter:string;
}

export class RainbowEntries
{
  static attribute = new ElementAttribute( "rainbow-entries" );
  static _updatingElements:Element[] = [];
  static _hasListeners = false;
  static _itemIndex = 0;
  static _itemsToUpdate = 1;

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    RainbowEntries.ensureUpdates( onAnimationFrame );
    this._updatingElements = RainbowEntries.attribute.queryDocAll();
  }

  static ensureUpdates( onAnimationFrame:OnAnimationFrame )
  {
    if ( this._hasListeners )
    {
      return;
    }

    onAnimationFrame.addListener( ()=> RainbowEntries._update() );
    this._hasListeners = true;
  }

  static _update()
  {
    if ( this._updatingElements.length === 0 )
    {
      return;
    }
    
    let ms = new Date().getTime();
    let intervall = 1000 * 40;
    let hueOffset = ( ms % intervall ) / intervall * 360 ;



    for ( let i = 0; i < this._itemsToUpdate; i++ )
    {
      this._itemIndex = MathX.repeat( this._itemIndex + 1, this._updatingElements.length );
      RainbowEntries.applyOnElement( this._updatingElements[ this._itemIndex ], hueOffset );
    }
  }

  static shiftTemperature( hue:number, amount:number )
  {
    let hsl = new HSLColor( hue, 100, 50 );

    if ( amount > 0 )
    {
      return hsl.warmen( amount ).h;
    }
    else
    {
      return hsl.coolen( - amount ).h;
    }

  }

  static _map:Map<number,RainbowStyle> = new Map();

  static _getStyle( hue:number ):RainbowStyle
  {
    hue = MathX.repeat( hue, 360 );
    let hueIndex = Math.round( hue * 10 );

    if ( ! RainbowEntries._map.has( hueIndex ) )
    {
      let shift = RainbowEntries.shiftTemperature;

      let topColor    = `hsl(${ shift( hue, 5 ) },60%,40%)`;
      let centerColor = `hsl(${ hue },80%,30%)`;
      let bottomColor = `hsl(${ shift( hue, -5 ) },100%,20%)`;

      let style = new RainbowStyle();

      style.background = `linear-gradient( 180deg, ${ topColor } 0%, ${ centerColor } 50%, ${ bottomColor } 100%)`;
      style.color = `hsl(${hue},100%,80%)`;

      this._map.set( hueIndex, style );

    }

    return RainbowEntries._map.get( hueIndex );
  } 

  static applyOnElement( e:Element, hueOffset:number = 0 )
  {
    hueOffset = Math.round( hueOffset );
    let entries = RainbowEntries.attribute.queryValueAllIn( e );
    
    let numSteps = 160;    
    
    for ( let i = 0; i < entries.length; i++ )
    {
      let hue = ( i % numSteps ) / numSteps * 360;
      let style = RainbowEntries._getStyle( hue + hueOffset );

      let entry = ( entries[ i ] as HTMLElement );
      let anchor = entry.querySelector( "a" );
      
      entry.style.background = style.background;
      entry.style.filter = style.filter;
      anchor.style.color = style.color;
    
    }
  }


}